import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { Store } from '@ngrx/store';

import { TaskActionHandler } from '../contracts/task-action.contract';
import { Task, TaskType } from '../models/task.interface';
import * as TaskActions from '../store/task.actions';

@Injectable()
export class ManualAppointmentCancellationActionHandler implements TaskActionHandler<TaskType.ManualAppointmentCancellation> {
  private readonly router = inject(Router);
  private readonly store = inject(Store);

  readonly type = TaskType.ManualAppointmentCancellation;

  execute(task: Task<TaskType.ManualAppointmentCancellation>): void {
    this.store.dispatch(TaskActions.startTask({ task }));
    this.router.navigate(['/tasks', task.id], { queryParams: { createdAt: task.createdAt.toISOString() } });
  }
}
